<template>
    <div v-loading="loading" class="py-4 mt-6 container-fluid page-shell">
        <div class="card soft-card soft-table-card">
            <div class="soft-card-header page-header-stats">
                <h6 class="mb-0">{{ $t("clinicsMedicalFacilities") }}</h6>
                <div class="header-stat-pills">
                    <div class="header-stat-pill">
                        <i class="bi bi-hospital-fill" aria-hidden="true"></i>
                        <span class="header-stat-pill__label">{{ $t("clinicSingular") }}</span>
                        <strong>{{ analitics?.[0] ?? "—" }}</strong>
                    </div>
                    <div class="header-stat-pill">
                        <i class="bi bi-capsule-pill" aria-hidden="true"></i>
                        <span class="header-stat-pill__label">{{ $t("clinicPharmacy") }}</span>
                        <strong>{{ analitics?.[1] ?? "—" }}</strong>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <grid-table :data-table="dataTable"></grid-table>
            </div>
        </div>
    </div>
</template>
<script>
import { getPolicyId } from "@/project/Source/routes";

import GridTable from './components/Table.vue'
import Source from "@/project/Source/claim.js"

export default {

    components: {
        GridTable,
    },
    data() {
        return {
            loading: false,
            analitics: null,
            dataTable: null,
            policy: null
        }
    },
    mounted() {
      
    },
    beforeMount() {
        const data = {
            "id": getPolicyId(this.$route),
            "requestCorrelationId": "string"
        }

        Source.Policy(data)
            .then((response) => {
                this.policy = response.data.data[0];
                sessionStorage.setItem("policy", JSON.stringify(this.policy.policyId));
                sessionStorage.setItem(
                    "policyNumber",
                    JSON.stringify(`${this.policy.policySeries}${this.policy.policyNumber}`)
                );
                this.loading = false;
            })
        Source.PolicyClinicsAnalitics(data).then((response) => {
            this.analitics = response.data
        })
    }
}
</script>
